export const getLocale = () => {
    try { return localStorage.getItem('locale') || 'en'; } catch { return 'en'; }
};

// Preload all JSON bundles at build time via Vite
const bundles = import.meta.glob('./locales/**/*.json', { eager: true });
// Structure: map[locale][namespace] = object
const registry = {};
Object.entries(bundles).forEach(([path, mod]) => {
    const parts = path.split('/');
    const locale = parts[parts.length - 2];
    const file = parts[parts.length - 1];
    const ns = file.replace(/\.json$/, '');
    registry[locale] = registry[locale] || {};
    registry[locale][ns] = (mod && mod.default) ? mod.default : mod;
});

// Helper function to get nested value using dot notation
const getNestedValue = (obj, path) => {
    if (!obj || !path) return null;
    return path.split('.').reduce((current, key) => current?.[key], obj);
};

export const tns = (ns, key, optionsOrLocale = getLocale()) => {
    let locale = getLocale();
    let params = {};

    if (typeof optionsOrLocale === 'string') {
        locale = optionsOrLocale;
    } else if (typeof optionsOrLocale === 'object' && optionsOrLocale !== null) {
        params = optionsOrLocale;
        if (params.locale) {
            locale = params.locale;
        }
    }

    const pack = registry?.[locale]?.[ns];
    const enPack = registry?.en?.[ns];
    let val = getNestedValue(pack, key) || getNestedValue(enPack, key) || key;

    // Interpolation
    if (val && typeof val === 'string' && Object.keys(params).length > 0) {
        Object.keys(params).forEach(k => {
            if (k !== 'locale') {
                val = val.replace(new RegExp(`{{${k}}}`, 'g'), params[k]);
            }
        });
    }
    return val;
};

export const tc = (key, optionsOrLocale = getLocale()) => tns('common', key, optionsOrLocale);

export default { tc, tns, getLocale };


